import React, { forwardRef } from "react";
import Modal from "react-bootstrap/Modal";
import AddInfo from "./AddInfo";
import Preview from "./Preview";
import UploadInfo from "./UploadInfo";

const SurveyForm = forwardRef(({ active, index }, ref) => {
  return (
    <>
      <Modal.Body>
        {active === "addInfo" && <AddInfo ref={ref} />}
        {active === "upload" && <UploadInfo />}
        {active === "preview" && <Preview />}
      </Modal.Body>
    </>
  );
});

export default SurveyForm;
